import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles((theme) => ({
	plotHint: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		padding: theme.spacing(1, 2),
		boxShadow: theme.shadows[1],
		borderRadius: theme.spacing(0.5)
	}
}))

export default useStyles
